import "./Header.css";
import { Link } from "react-router-dom";
import NewLogo from "../../Images/NewLogo.png";

const headerLogoStyle = {
	width: "2.8rem",
	margin: "10px 5px 10px 10px",
};

export default function Header() {
	return (
		<header className="header">
			<div className="leftHeaderDiv">
				<img style={headerLogoStyle} src={NewLogo} />
				<h2 style={{ fontFamily: 'Poppins' , fontWeight: "600", color: "white" }}>
					<Link id="GCP" to="/">
						GCP
					</Link>
				</h2>
				<div className="games-dropdown">
					<span id="games" style={{ margin: "0 1rem 2rem 4rem", }}>
						Games
					</span>
					<div class="games-dropdown-content">
						<Link to="/games/arrays">Arrays</Link>
						<Link to="/games/searching">Searching</Link>
						<Link to="/games/sorting">Sorting 🔒</Link>
						<Link to="/games/hashing">Hashing 🔒</Link>
						<Link to="/games/strings">Strings 🔒</Link>
						<Link to="/games/xor">XOR 🔒</Link>
						<Link to="/games/recursion">Recursion 🔒</Link>
						<Link to="/games/bit-manip">Bitmanip 🔒</Link>
						<Link to="/games/linked-lists">Linked Lists 🔒</Link>
						<Link to="/games/stacks">Stacks 🔒</Link>
						<Link to="/games/queues">Queues 🔒</Link>
						<Link to="/games/trees">Trees (3) 🔒</Link>
						<Link to="/games/graphs">Graphs (4) 🔒</Link>
						<Link to="/games/greedy">Greedy Algorithms 🔒</Link>
						<Link to="/games/backtracking">Backtracking 🔒</Link>
						<Link to="/games/dp">Dynamic Programming 🔒</Link>
					</div>
				</div>
				<Link to="/pricing">
                    <span id="pricing">Pricing</span>
                </Link>
			</div>
			<div className="rightHeaderDiv">
				<span>Sign Up/Login</span>
			</div>
		</header>
	);
}
